import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { type Organization } from './organization';
import { BaseModel } from './basemodel';
import { FeatureFlag } from './featureFlags';
import { UserPermissionScope } from './user-permissions';

_('ADMIN');
_('MANAGER');
_('USER');
_('WORKFLOW_EDITOR');
_('JOB_MANAGER');
_('JOB_UPLOADER');
_('WORKER_MANAGER');
_('WORKER');

export enum SecondaryUserFilter {
    WITHOUT_SECONDARY_USERS = 'WITHOUT_SECONDARY_USERS',
    WITH_SECONDARY_USERS = 'WITH_SECONDARY_USERS',
    ONLY_SECONDARY_USERS = 'ONLY_SECONDARY_USERS'
}


export enum UserRole {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  USER = 'USER',
  WORKFLOW_EDITOR = 'WORKFLOW_EDITOR',
  JOB_MANAGER = 'JOB_MANAGER',
  JOB_UPLOADER = 'JOB_UPLOADER',
  WORKER_MANAGER = 'WORKER_MANAGER',
}

export const LOWEST_USER_ROLE = UserRole.USER;

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface User extends BaseModel {
  sub: string; // Id of the user in Keycloak

  created_at: string; // Date of creation in Keycloak

  userId?: string; // Id of the user in the database (mapped by Keycloak)

  email: string;

  preferred_username: string;

  given_name?: string;

  family_name?: string;

  role: UserRole;

  roles?: UserRole[];

  featureFlags: FeatureFlag[];

  permissions?: string[];

  permissionScopes?: UserPermissionScope[];

  hasAllPermissions?: boolean;

  group: string[];

  status: UserStatus;

  organization: Organization;

  verificationCode?: string;

  newPassword?: string;

  organizationId?: string;

  sid: string; // Session ID in Keycloak

  locale: string; // Language preference in Keycloak

  isOrganizationOwner: boolean;

  secondaryOrganizations: Organization[];

  currentOrganization?: Organization;

  isSecondaryOrgMember: boolean;
}
